type ProgressBarSimplifiedProps = {
  current: number;
  total: number;
};

export const ProgressBarSimplified: React.FC<ProgressBarSimplifiedProps> = ({
  current,
  total,
}) => {
  const percentage = Math.min((current / total) * 100, 100);

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex justify-between items-center">
        <span className="body-3-bold font-primary">{current}</span>
        <span className="body-3-bold font-quaternary">/ {total}</span>
      </div>
      <div className="w-full h-2 surface-quaternary rounded-full overflow-hidden">
        <div
          className="h-full surface-font-success transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};
